<template>
  <div class="app-body">
    <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
        ref="queryForm"
        class="query-form"
    >
      <el-form-item label="外销合同编号：">
        <order-drop v-model="dataForm.orderCode"></order-drop>
      </el-form-item>
      <el-form-item label="" label-width="0">
        <el-checkbox v-model="dataForm.isFuzzy">模糊搜索</el-checkbox>
      </el-form-item>
      <el-form-item label="供应商：" v-if="$hasPermission('trade:purchasea:query:company')">
        <company
            v-model="dataForm.companyId"
            @change="reload"
            :clearable="true"
        ></company>
      </el-form-item>
      <el-form-item label="收货仓库：" v-if="$hasPermission('trade:purchasea:query:storage')">
        <storages
            v-model="dataForm.storageId"
            @change="reload"
            :clearable="true"
            :showBtn="false"
        />
      </el-form-item>
      <el-form-item prop="productName" label="品名：">
        <el-input
            v-model="dataForm.productName"
            size="mini"
            clearable
            type="text"
            placeholder="品名"
            style="width: 240px;"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productColor" label="颜色：">
        <el-input
            v-model="dataForm.productColor"
            size="mini"
            clearable
            type="text"
            placeholder="请输入颜色"
            style="width: 200px;"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productSize" label="规格：">
        <el-input
            v-model="dataForm.productSize"
            size="mini"
            clearable
            type="text"
            placeholder="请输入规格"
            style="width: 200px;"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productAttr1" label="幅宽：">
        <el-input
            v-model="dataForm.productAttr1"
            size="mini"
            clearable
            type="text"
            placeholder="请输入幅宽"
            style="width: 200px;"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productAttr2" label="克重：">
        <el-input
            v-model="dataForm.productAttr2"
            size="mini"
            clearable
            type="text"
            placeholder="请输入克重"
            style="width: 200px;"
        ></el-input>
      </el-form-item>
      <el-form-item prop="creatorName" label="下单人：">
        <el-input
            v-model="dataForm.creatorName"
            size="mini"
            clearable
            type="text"
            placeholder="请输入下单人姓名"
            style="width: 240px;"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="reload()" size="mini" type="primary">{{ $t('query') }}</el-button>
      </el-form-item>
    </el-form>
    <div class="table-bar" style="justify-content: left;margin-bottom: 0px;">
      <el-button class="bar-item" type="primary" size="mini" @click="doCreate()" icon="el-icon-plus"
                 v-if="$hasPermission('trade:purchaseagreement:save')">创建采购合同
      </el-button>
      <el-button class="bar-item" type="warning" size="mini" @click="importPurchase()" icon="el-icon-upload2"
                 v-if="$hasPermission('trade:purchaseagreement:save')">导入采购合同
      </el-button>
      <el-button class="bar-item" type="primary" size="mini" @click="showExportDialog()" icon="el-icon-download">下载合同
      </el-button>
      <el-button class="bar-item" type="danger" size="mini" v-if="$hasPermission('erp:purchase:delete')"
                 @click="doDel()"
                 icon="el-icon-delete">批量删除
      </el-button>
      <el-button class="bar-item" type="primary" size="mini" v-if="$hasPermission('purchase:copy')" @click="doCopy()"
                 icon="el-icon-copy-document">批量复制
      </el-button>
      <el-button class="bar-item" type="danger" size="mini" v-if="$hasPermission('erp:purchase:check')"
                 @click="doCheck()"
                 icon="el-icon-s-promotion">发送采购单
      </el-button>
      <el-button class="bar-item" type="warning" size="mini" v-if="$hasPermission('erp:purchase:checkin:batch')"
                 @click="showSendDialog()"
                 icon="el-icon-s-promotion">批量收货
      </el-button>
      <el-button class="bar-item" type="warning" size="mini" v-if="$hasPermission('erp:purchase:receipt:batch')"
                 @click="showReceiptImportDialog()"
                 icon="el-icon-s-promotion">采购进项发票导入
      </el-button>
      <el-button class="bar-item" type="warning" size="mini" v-if="$hasPermission('erp:purchase:cancel:send')"
                 @click="cancelSendStatus()"
                 icon="el-icon-s-promotion">撤回已发送订单
      </el-button>
    </div>
    <SweetTable ref="table" :selection="true" url="/erp/purchase/page" delete-url="/erp/purchase"
                :query-form="dataForm" :before-table-binding="beforeTableBinding" api-version="v2">
      <el-table-column
          prop="orderCode"
          label="外销合同编号"
          header-align="center"
          align="center"
          min-width="110"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="batchCode"
          label="批次号"
          header-align="center"
          align="center"
          width="110"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="product.name"
          label="品名"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="product.color"
          label="颜色"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="product.size"
          label="规格"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="product.attr1"
          label="幅宽"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="product.attr2"
          label="克重"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column prop="amount" label="单价" width="100" header-align="center" align="center">
      </el-table-column>
      <el-table-column
          prop="count"
          label="计划数"
          header-align="center"
          align="center"
          width="80"
      >
      </el-table-column>
      <el-table-column
          label="已收货"
          header-align="center"
          align="center"
          prop="receiptCount"
          width="80"
      >
      </el-table-column>
      <el-table-column
          label="开票单价"
          header-align="center"
          align="center"
          prop="receiptPrice"
          width="80"
      >
      </el-table-column>
      <!--      <el-table-column-->
      <!--          prop="realPriceShow"-->
      <!--          label="开票单价"-->
      <!--          header-align="center"-->
      <!--          align="center"-->
      <!--          width="100"-->
      <!--      >-->
      <!--        <template slot-scope="scope">-->
      <!--          <el-tooltip effect="dark" :content="String(scope.row.realPrice)" placement="right">-->
      <!--            <div>{{ scope.row.realPriceShow }}</div>-->
      <!--          </el-tooltip>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <el-table-column
          prop="companyName"
          label="供应商"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
          :formatter="$c.companyNameFormatter"
          min-width="160"
      ></el-table-column>
      <el-table-column
          label="收货仓库"
          header-align="center"
          align="center"
          prop="storageName"
          :show-overflow-tooltip="true"
          :formatter="$c.companyNameFormatter"
          min-width="160"
      >
      </el-table-column>
      <el-table-column
          label="状态"
          header-align="center"
          align="center"
          width="80"
      >
        <template #default="{row}">
          <send-status :status="row.status"></send-status>
        </template>
      </el-table-column>

      <el-table-column
          label="制单人"
          header-align="center"
          align="center"
          prop="creatorName"
          width="120"
          :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
          label="制单时间"
          header-align="center"
          align="center"
          prop="createDate"
          width="160"
          :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
          label="上游物料"
          prop="parentNames"
          header-align="center"
          align="center"
          width="120"
          :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
          :label="$t('handle')"
          header-align="center"
          align="center"
          width="140"
          fixed="right"
      >
        <template slot-scope="scope">
          <div class="flex flex-wrap justify-center">
            <el-dropdown @command="e=>{handleCommand(e,scope.row)}">
              <el-button type="text" icon="el-icon-arrow-down" size="mini">更多操作</el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="修改"
                                  v-if="$hasPermission('trade:purchaseagreement:update')">
                  修改
                </el-dropdown-item>
                <el-dropdown-item command="上游物料">上游物料</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </template>
      </el-table-column>
    </SweetTable>
    <DetailDialog ref="detailDialog"></DetailDialog>
    <CheckInDialog
        ref="checkInDialog"
        @refreshDataList="getDataList"
    ></CheckInDialog>
    <!--    <common-upload-->
    <!--        ref="uploader"-->
    <!--        @success="uploadSuccessHandler"-->
    <!--        uploadUrl="/trade/purchase/import/check/in"-->
    <!--        templateUrl="/static/template/采购账单明细导入模板.xlsx"-->
    <!--        title="采购账单明细导入"-->
    <!--    ></common-upload>-->
<!--    <common-upload-->
<!--        ref="purchaseUploader"-->
<!--        @success="purchaseUploadSuccessHandler"-->
<!--        uploadUrl="/trade/purchase/import"-->
<!--        templateUrl="/static/template/采购合同批量导入模板.xlsx"-->
<!--        title="采购合同批量导入"-->
<!--    ></common-upload>-->
    <EditDialog ref="editDialog" @change="getDataList"></EditDialog>
    <ExportDialog ref="exportDialog"></ExportDialog>
    <change-order-dialog ref="ChangeOrderDialog" @refreshDataList="getDataList"></change-order-dialog>
    <UpFlowDialog ref="UpFlowDialog" @refreshDataList="getDataList"></UpFlowDialog>
    <SendDialog ref="SendDialog" @change="getDataList"></SendDialog>
    <ReceiptImportDialog ref="ReceiptImportDialog" @change="getDataList"></ReceiptImportDialog>
    <CreateDialog ref="createDialog" @change="reload"></CreateDialog>
  </div>
</template>

<script>
import CreateDialog from '@/views/modules/erp/purchase/create-dialog.vue'
import SendDialog from '@/views/modules/erp/client/common/PurchaseSendDialog.vue'
import DetailDialog from './agreement/detail-dialog.vue'
import CheckInDialog from './check-in'
import EditDialog from './edit-dialog.vue'
import ExportDialog from './export-dialog'
import BigNumber from 'bignumber.js'
import ChangeOrderDialog from '@/views/modules/trade/purchase/change-order-dialog'
import UpFlowDialog from '@/views/modules/erp/bom/up-flow-dialog.vue'
import SweetTable from '@/mixins/SweetTable'
import ReceiptImportDialog from '@/views/modules/erp/purchase/receipt-import-dialog.vue'
import SendStatus from '@/views/modules/erp/common/send-status.vue'

export default {
  mixins: [SweetTable],
  components: {
    SendStatus,
    DetailDialog,
    CheckInDialog,
    EditDialog,
    ExportDialog,
    ChangeOrderDialog,
    UpFlowDialog,
    SendDialog,
    ReceiptImportDialog, CreateDialog
  },
  data () {
    return {
      dateArr: [],
      currentId: '',
      dataForm: {
        storageId: '',
        companyId: '',
        orderCode: '',
        productName: '',
        productColor: '',
        productSize: '',
        productAttr1: '',
        productAttr2: '',
        creatorName: '',
        isFuzzy: false
      },
    }
  },
  methods: {
    async cancelSendStatus(){
      let rows=this.$refs.table.dataListSelections
      if(this.$c.isArrayEmpty(rows)){
        return this.$message.error('请选择要操作的数据')
      }
      this.$confirm(`是否取消【${rows.length}】个采购单的发货状态？`, '操作提示').then(() => {
        this.$api2.post(`/erp/purchase/cancel/send`, { ids: rows.map(item => item.id) }).then(res => {
          this.clearSelection()
          this.getDataList()
        })
      })
    },
    showReceiptImportDialog () {
      this.$refs.ReceiptImportDialog.sendType = 'purchase'
      this.$refs.ReceiptImportDialog.init()
    },
    //显示批量收货弹窗(工厂端的发货弹窗)
    showSendDialog () {
      this.$refs.SendDialog.sendType = 'purchase'
      this.$refs.SendDialog.init()
    },
    //确认采购信息
    doCheck () {
      if (this.$c.isArrayEmpty(this.$refs.table.dataListSelections)) {
        return this.$message.error('请选择要操作的数据')
      }
      this.$confirm(`是否要将【${this.$refs.table.dataListSelections.length}】个采购单发送给供应商，发送后采购单将无法修改和删除！`, '操作提示').then(() => {
        this.$api2.post(`/erp/purchase/check`, { ids: this.$refs.table.dataListSelections.map(item => item.id) }).then(res => {
          this.clearSelection()
          this.getDataList()
        })
      })
    },
    doCopy () {
      if (this.$c.isArrayEmpty(this.$refs.table.dataListSelections)) {
        return this.$message.error('请选择要操作的数据')
      }
      window.localStorage.setItem('purchase_copy_data', JSON.stringify(this.$refs.table.dataListSelections))
      this.$router.push(`/trade/purchase/copy`)
    },
    //SweetTable已封装批量删除方法,此处为了兼容旧代码
    doDel () {
      let selList = this.$refs.table.dataListSelections
      if (this.$c.isArrayEmpty(selList)) {
        return this.$message.error('请选择要删除的数据')
      }
      let params = {
        ids: selList.map(item => item.id)
      }
      this.$confirm(`是否删除【${selList.length}】条记录?`, '操作提示').then(() => {
        this.$api2.delete('/erp/purchase', { data: params }).then(res => {
          this.getDataList()
        })
      })
    },
    showChangeOrderDialog (row) {
      this.$refs.ChangeOrderDialog.init(row.id)
    },
    handleCommand (e, row) {
      if (e == '修改') {
        this.doEdit(row)
      } else if (e == '上游物料') {
        this.showForwardDialog(row)
      } else if (e == '退货') {
        this.go2Back(row)
      } else if (e == '切换订单') {
        this.showChangeOrderDialog(row)
      }
    },
    //显示上游物料设置弹窗
    showForwardDialog (row) {
      this.$refs.UpFlowDialog.init(row.agreementId, row.productId)
    },
    doEdit (row) {
      this.$refs.editDialog.id = row.id
      this.$refs.editDialog.init()
    },
    beforeTableBinding (dataList) {
      if (!dataList || dataList.length === 0) {
        return
      }
      dataList.forEach(item => {
        if (item.receiptCount === 0) {
          item.receiptPrice = 0
        } else {
          item.receiptPrice = new BigNumber(item.receiptAmount).dividedBy(item.receiptCount).toFixed(3)
        }
        try {
          if (!this.$c.isArrayEmpty(item.parentMaterialList)) {
            item.parentNames = item.parentMaterialList.map(p => this.$c.productName(p)).join(',')
          }
        } catch (e) {
          console.log(e)
        }
      })
    },
    showExportDialog () {
      if (this.$c.isArrayEmpty(this.$refs.table.dataListSelections)) {
        return this.$message.error('请选择采购合同明细')
      }
      this.$refs.exportDialog.ids = this.$refs.table.dataListSelections.map(item => item.id).join(',')
      this.$refs.exportDialog.init()
    },

    successHandle (res, file, fileList) {
      if (res.code != 0) {
        this.$message.error(res.msg)
      }
      console.log('successHandle', fileList, res)
    },
    errorHandle (err, file, fileList) {
      console.log('errorHandle', err)
    },
    //添加采购合同
    doCreate () {
      this.$router.push(`/trade/purchase/create`)
    },
    importPurchase () {
      this.$refs.createDialog.init()
    },
    importCheckIn () {
      this.$refs.uploader.init()
    },
    uploadSuccessHandler (e) {
      this.reload()
    },
    purchaseUploadSuccessHandler (e) {
      this.reload()
    },
    showDetailDialog (row) {
      this.$refs.detailDialog.id = row.id
      this.$refs.detailDialog.init()
    },
    // TODO:移除route里的/store-manager/save
    // go2Back (row) {
    //   this.$router.push(`/store-manager/save?type=1&productType=2&orderCode=${row.agreementCode}&storageId=${row.storageId}`)
    // },
    // //采购入库
    // doCheckIn (row) {
    //   this.$router.push(`/store-manager/save?type=1&productType=2&orderCode=${row.agreementCode}&storageId=${row.storageId}`)
    // },
    addOrUpdateHandle (row) {
      let id = ''
      if (row) {
        id = row.id
      }
      this.$router.push(`/trade/purchase/agreement/save?id=${id}`)
    },
  },
}
</script>

<style lang="scss" scoped>
.count-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 10px;
}
</style>
